module.exports = __webpack_public_path__ + "img/9-8.272d56b4.png";